module.exports = __webpack_public_path__ + "static/media/KOMUNIKACJA.ad46fe34.png";